import { FunctionComponent } from "react";

export const DateCell: FunctionComponent = ({ children }) => (
    <td style={{ whiteSpace: "nowrap", verticalAlign: "text-top", padding: 0 }}>
        {children}
    </td>
);
